export default __webpack_public_path__ + "static/banner-proviotics-1-0980f24c02647d2bb02904e7cdd9a6aa.png";